import {formatBalance} from "../utils";
import {Button} from "../components/Button";
import {RoundedModal} from "../components/Modal";
import React, {useEffect} from "react";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import closePurple from "../assets/icons/modal/close-purple@2x.png";
import {useDispatch, useSelector} from "react-redux";
import UIState from "../store/uiState";
import Wallet, {
    selectBalances,
    selectCurrentAccount,
    selectNFTBalances,
    selectProvider,
    selectStakingAPY
} from "../store/models/wallet";
import cardNew from "../assets/icons/card/new@2x.png";
import cardSoldOut from "../assets/icons/card/sold-out@2x.png";
import cardExclusive from "../assets/icons/card/exclusive@2x.png";
import _ from "lodash";
import classNames from "classnames";
import tokenIcon from "../assets/logos/grove@2x.png";
import {StakeAPYCTA, StakeAPYEarnInfo, StakeAPYInfo} from "../components/CTAPill";
import {ethers} from "ethers";

export const StakeModal = ({defaultAmountToStake}) => {
    const dispatch = useDispatch();
    const currentAccount = useSelector(selectCurrentAccount);
    const balances = useSelector(selectBalances);
    const groveTokenOnHand = balances?.groveTokenOnHand;
    const stakingAPY = useSelector(selectStakingAPY);

    useEffect(() => {
        dispatch(Wallet.actions.fetchStakingAPY());
        }, []);

    const onStake = () => {
        dispatch(Wallet.actions.depositStake(defaultAmountToStake));
    }

    const onClose = () => {
        console.log('close');
        dispatch(UIState.actions.hideModal());
    }

    return (
        <RoundedModal title={null}
                      header={<div>
                          <a onClick={onClose}
                             className={'StakeModal__close'}
                          >
                              <img src={closePurple}/>
                          </a>
                      </div>}
                      className={classNames('StakeModal', {
                          'StakeModal--stake': true,
                      })}
        >
            <div className={'StakeModal__name'}>
                Stake GROVE
            </div>
            <StakeAPYEarnInfo/>

            <div className={'StakeModal__description'}>

                {/*<div>*/}
                {/*    {`and earn up to ${stakingAPY ? stakingAPY : '~' }% APY`}*/}
                {/*</div>*/}
                <div>
                    Unstake your GROVE at any time
                </div>
            </div>
            {
                groveTokenOnHand &&
                <div className={'StakeModal__token-amount'}>
                    <img src={tokenIcon}/>
                    <span>
                        {formatBalance(defaultAmountToStake)}
                    </span>
                    {/*// TODO edit button?*/}
                </div>
            }
            {
                !_.isNil(currentAccount) &&
                <Button className={'StakeModal__button'}
                        color={'red'}
                        size={'large'}
                        style={{width: '100%'}}
                        onClick={onStake}
                >
                    Stake
                </Button>
            }

        </RoundedModal>
    )
}

export default StakeModal;